export const FAQ_PAGE_LIMIT = 10;
